import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import ProfileBA from "./BA/ProfileBA";
import ProfileAccount from "./Account/ProfileAccount";
import ProfileBrand from "./ProfileBrand/ProfileBrand";
import CircularProgress from "@mui/material/CircularProgress"; // Import MUI CircularProgress

const ProfileRouter = () => {
  const { username } = useParams();
  const [profileData, setProfileData] = useState<any>(null); // Store profile data
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await fetch(
          `${
            import.meta.env.VITE_API_URL
          }/profiles/check-profile?username=${username}`
        );
        const data = await response.json();

        if (data.length > 0) {
          setProfileData(data[0]); // Store the entire profile data
        } else {
          setProfileData(null); // No user found
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, [username]);

  if (loading) {
    // Replace the loading text with MUI loading icon
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (!profileData) {
    return <Navigate to="/" />; // Handle unknown profile type
  }

  const { user_id, type } = profileData; // Destructure profile data

  switch (type) {
    case "Account":
      return (
        <ProfileAccount
          accountId={profileData.account_id}
          username={profileData.username}
        />
      );
    case "BA":
      return (
        <ProfileBA
          baId={user_id}
          username={profileData.username}
          isModal={false}
          isOpen={true}
          onClose={() => {}}
        />
      );
    case "Brand":
      return (
        <ProfileBrand
          brandId={profileData.brand_id}
          username={profileData.username}
        />
      );
    default:
      return <Navigate to="/" />; // Handle unknown profile type
  }
};

export default ProfileRouter;
